import classNames from "classnames";
import * as React from "react";
import { State } from "source/app/services/UI/State/State";
import { ESharedComponent } from "../../../services/UI/State/ESharedComponent";
import * as styles from "./StatusBar.css";
import {
    emptyStatusMessage,
    IStatusMessage,
} from "./StatusMessage/StatusMessage";
import {
    EStatusMessageType,
    GetBackground,
    GetStatusMessageColor,
} from "./StatusMessageType/StatusMessageType";

export interface StatusBarState {
    message: IStatusMessage;
    timeoutId: number;
}

const initialState: StatusBarState = {
    message: emptyStatusMessage,
    timeoutId: 0,
};

class StatusBar extends React.Component<{}, StatusBarState> {
    state = initialState;

    async componentDidMount() {
        State.ShareClass(ESharedComponent.StatusBar, this);
    }

    componentDidUpdate() {
        State.ShareClass(ESharedComponent.StatusBar, this);
    }

    // Required to prevent unncessary renders
    // when Data.Load.All() is called
    shouldComponentUpdate(nextProps: {}, nextState: StatusBarState) {
        return (
            JSON.stringify(nextProps) !== JSON.stringify(this.props) ||
            JSON.stringify(nextState) !== JSON.stringify(this.state)
        );
    }

    render() {
        return (
            <div
                id="pnlStatusBar"
                className={classNames("marginBottomHalfem", [styles.statusBar])}
                style={{
                    color: GetStatusMessageColor(this.state.message),
                    textShadow: `0px 0px 10px ${GetStatusMessageColor(
                        this.state.message
                    )}`,
                    background: GetBackground(this.state.message),
                    opacity: this.state.message.text ? 1 : 0,
                    transition: `all 1s ease`,
                }}
            >
                {this.state.message.text}
            </div>
        );
    }
}

export default StatusBar;

export function AddStatusMessage(
    text: string,
    type: EStatusMessageType,
    duration?: number
) {
    try {
        AddStatus({ text, type, duration });
    } catch (e) {
        if (e.message !== errorMessageMissingStatusBarClass) {
            throw e;
        }
    }
}

const errorMessageMissingStatusBarClass = `Cannot read StatusBar class`;

function AddStatus(message: IStatusMessage) {
    if (!message.text) {
        throw new Error("Missing message text");
    }

    const statusBar = GetStatusBar();

    if (!statusBar) {
        throw new Error(errorMessageMissingStatusBarClass);
    }

    const ClearAnyExistingTimeouts = () =>
        window.clearTimeout(statusBar.state.timeoutId);
        
    ClearAnyExistingTimeouts();

    const ClearStatusBar = () => {
        statusBar.setState(initialState);
    };

    const messageDuration =
        message.duration ?? GetMessageDuration(message.text);

    var timeoutId = window.setTimeout(ClearStatusBar, messageDuration);
    statusBar.setState({ message, timeoutId });
}

function GetStatusBar() {
    const statusBar = State.ReadClass<StatusBarState>(
        ESharedComponent.StatusBar
    );

    if (statusBar && statusBar.state) {
        return statusBar;
    }

    return undefined;
}

function GetMessageDuration(quote: string) {
    const millisecondsPerCharacter = 70;
    const duration = quote.length * millisecondsPerCharacter;
    return duration;
}
